import React from 'react';
import { ButtonToolbar, ToggleButtonGroup, FormGroup, ControlLabel } from 'react-bootstrap';
import './ToggleGroup.scss';

export interface ToggleGroupProps {
    name: string;
    label?: string;
    value?: any | any[];
    defaultValue?: any | any[];
    onChange?: (value: any) => void;
    children: React.ReactNode;
}

export const ToggleGroup: React.FC<ToggleGroupProps> = (props) => {

    const id = `${props.name}-id`;

    const conditionalControlIdProps = props.label ? { controlId: id } : {}

    return (
        <FormGroup {...conditionalControlIdProps}>
            { props.label && <ControlLabel>{props.label}</ControlLabel> }
            <ButtonToolbar>
                <ToggleButtonGroup type="radio" bsStyle="primary" {...props}>
                    {props.children}
                </ToggleButtonGroup>
            </ButtonToolbar>
        </FormGroup>
    );
}

(ToggleGroup as any).displayName = 'ToggleGroup'